import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const NoAccessPage = (): unknown => {
    return import(/* webpackPrefetch: true */ './no-access-page.vue');
};

export const noAccessPageRoute: RouteRecordRaw = {
    ...ROUTE_DATA.NO_ACCESS_PAGE,
    component: NoAccessPage,
    props: (route) => {
        return { errorCode: routerHelper.parseParamToInt(route.params.id as string, null) };
    }
};
